// extracted by mini-css-extract-plugin
module.exports = {"imageContainer":"ImageSlide_imageContainer__ETH6N","imagePane":"ImageSlide_imagePane__7l5mV","fade":"ImageSlide_fade__1ALs9","fadeOut":"ImageSlide_fadeOut__2eO-V"};